import { hasAudienceAmendsContent } from "../../amends/lib/audience-aware-amends.mjs"

export function isLeadingSummaryGroupValid(group = {}) {
    const { valid } = analyzeLeadingSummaryGroup(group)
    return valid
}

export function analyzeLeadingSummaryGroup(group = {}) {
    const hasSchedules = hasLeadingSummaryGroupSchedules(group)
    const hasLeadingSummaryContent = hasLeadingSummaryGroupContent(group)
    const hasLegislation = getConfiguredLeadingSummaryLegislationCount(group) > 0

    return {
        hasSchedules,
        hasLeadingSummaryContent,
        hasLegislation,
        valid: hasSchedules && (hasLeadingSummaryContent || hasLegislation),
    }
}

export function hasLeadingSummaryGroupSchedules(group = {}) {
    return (group?.leadingSummaryTypeSchedules?.length ?? 0) > 0
}

function hasLeadingSummaryGroupContent(group = {}) {
    return hasAudienceAmendsContent(group?.leadingSummary ?? {})
}

function getConfiguredLeadingSummaryLegislationCount(group = {}) {
    const legislation = Array.isArray(group?.legislation) ? group.legislation : []
    const legislationData = Array.isArray(group?.legislationData) ? group.legislationData : []
    return Math.max(legislation.length, legislationData.length)
}
